import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';
import { NotificacionCorreoRequest } from 'src/app/global/interfaces/notificacion-correo-request';
import { NotificacionCorreoService } from 'src/app/view-model/services/notificacion-correo.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class NotificacionCorreoProvider extends NotificacionCorreoService {

  private api = environment.api;
  private endpoints = this.api.endpoints.PASO_1;

  constructor(
      private http: HttpClient
  ) {
      super();
  }

  /**
     * @description Método que sirva para guardar correo en notificaciones para enviar comunicaciones de un tipo en particular
     * @returns Retorna un OBservable de MensajeDTO
     */
  public guardarCorreoNotificacion(correo: string, telefono: number, tipoNotificacion: string): Observable<GeneralResponse<any>> {
    const endpoint = this.api.host + this.api.path + this.endpoints.guardarCorreoNotificacion;
    const data: NotificacionCorreoRequest = {
      correo, telefono, tipoNotificacion
    };
    return this.http.post<GeneralResponse<any>>(endpoint, data);
  }
}
